import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * FilterOptions Icon
 *
 * @file FilterOptions.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

const FilterOptions = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 16 15" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.799631 3.20283H1.7432C2.19521 4.4482 3.57122
      5.09136 4.81659 4.63935C5.48456 4.39691 6.01067 3.8708
      6.25311 3.20283H15.193C15.6346 3.20283 15.9926
      2.84482 15.9926 2.4032C15.9926 1.96157 15.6346
      1.60357 15.193 1.60357H6.25311C5.8011 0.358189
      4.42509 -0.284962 3.17972 0.167045C2.51175
      0.409485 1.98564 0.935594 1.7432 1.60357H0.799631C0.358007
      1.60357 0 1.96157 0 2.4032C0 2.84482 0.358007 3.20283
      0.799631 3.20283ZM13.5937 4.8019C12.5796 4.80475
      11.6768 5.44502 11.3388 6.40117H0.799631C0.358007
      6.40117 0 6.75917 0 7.2008C0 7.64242 0.358007
      8.00043 0.799631 8.00043H11.3388C11.7804 9.24952
      13.151 9.90411 14.4001 9.46248C15.6492 9.02085
      16.3038 7.65025 15.8621 6.40115C15.5225 5.44035
      14.6128 4.79905 13.5937 4.8019ZM9.45164 11.1991H15.193C15.6346
      11.1991 15.9926 11.5571 15.9926 11.9988C15.9926
      12.4404 15.6346 12.7984 15.193 12.7984H9.45164C9.2092
      13.4664 8.68309 13.9925 8.01512 14.2349C6.76974 14.6869
      5.39373 14.0438 4.94172 12.7984H0.799631C0.358007 12.7984 0
      12.4404 0 11.9988C0 11.5571 0.358007 11.1991 0.799631
      11.1991H4.94172C5.18416 10.5312 5.71027 10.0051 6.37824
      9.76261C7.62362 9.31061 8.99962 9.95376 9.45164 11.1991Z"
      fill="currentcolor"
    />
  </SvgIcon>
);

export default FilterOptions;
